import React from 'react';

const TaxImportantNoticeCard = ({
  isUsUser = false
}) => {
  return (
    <>
      {isUsUser ? (
        <div className="d-flex gap-3 mb-4 important_notice_card">
          <div>
            <i className="fa-solid fa-circle-info"></i>
          </div>
          <div className="w-full">
            <h4>Important Notice</h4>
            <p>
              Congratulations 🎊 You have exceeded $599 in earnings, what a milestone!
              To continue cashing out your earnings please fill out and submit the W-9 form below.
            </p>
            <p>
              Make sure to complete all required fields (*) and ensure your information
              matches your official tax documents.
            </p>
          </div>
        </div>
      ) : (
        <div className="d-flex gap-3 mb-4 important_notice_card">
          <div>
            <i className="fa-solid fa-circle-info"></i>
          </div>
          <div className="w-full">
            <h4>Important Notice</h4>
            <p>
              Make sure to complete all required fields (*) and ensure your information
              matches your official tax documents.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default TaxImportantNoticeCard;
